import {header} from "./header/header.js";
import {animations} from "./animations/animations.js";
import {firstAnimations} from "./animations/parts/first-animations.js";

export const preloader = ()=> {
    const preloader = document.querySelector('.preloader')

    if (preloader) {
        const page = document.querySelector('#page');
        document.body.classList.add('overflow-hidden');
        page.classList.add('o-hidden');
        setTimeout(() => {
            preloader.classList.add('show');
        }, 100);

        document.addEventListener("DOMContentLoaded", (event) => {
            const timeouts = {
                removePreloader: 1200,
                headerStart: 1200,
                startAnimations: 700,
            }

            const showSite = () => {
                preloader.classList.add('hide');
                document.documentElement.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden');
                page.classList.remove('o-hidden');

                firstAnimations()

                setTimeout(() => {
                    animations();
                }, timeouts.startAnimations)

                setTimeout(() => {
                    header();
                }, timeouts.headerStart)

            }

            setTimeout(()=> {
                showSite();
            },timeouts.removePreloader)

        });
    } else {
        document.addEventListener("DOMContentLoaded", (event) => {
            let scriptLaunchStart = true;

            header();

            firstAnimations()

            const scriptLaunch = () => {
                animations();
            }
            if(window.pageYOffset >= 1 && scriptLaunchStart){
                scriptLaunchStart = false;
                scriptLaunch();
            } else if(window.pageYOffset < 1 && scriptLaunchStart){
                const events = ['mousemove', 'click', 'mousewheel', 'scroll', 'touchstart', 'keydown', 'keypress', 'mouseover', 'mouseout', 'resize'];
                events.forEach(event => {
                    window.addEventListener(event, () => {
                        if(scriptLaunchStart){
                            scriptLaunchStart = false;
                            scriptLaunch();
                        }
                    });
                });
            }

        });
    }
}